const forgetPasswordEndpointParamsSchema = (email, redirect_url) => ({
  email,
  redirect_url,
});

export default forgetPasswordEndpointParamsSchema;



// WEBPACK FOOTER //
// ./src/containers/ForgetPasswordForm/schemas.js